import { type PropType } from 'vue'
import { UPDATE_MODEL_VALUE } from '../../constants'
import type { TooltipPlacement, TooltipSide } from '../../directives/teleport-types'

export type { TooltipPlacement, TooltipSide }

export interface TooltipProps {
    modelValue?: boolean,
    hover?: boolean,
    focus?: boolean,
    offset?: number,
    placement?: TooltipPlacement,
    arrow?: boolean,
    color?: 'black' | 'blue',
    width?: string,
    maxWidth?: string,
    disabled?: boolean,
    content?: string | number,
}

export const tooltipProps = {
    modelValue: {
        type: Boolean as PropType<TooltipProps['modelValue']>,
        default: undefined,
        required: false,
    },
    hover: {
        type: Boolean as PropType<TooltipProps['hover']>,
        default: undefined,
        required: false,
    },
    focus: {
        type: Boolean as PropType<TooltipProps['focus']>,
        default: true,
        required: false,
    },
    offset: {
        type: Number as PropType<TooltipProps['offset']>,
        default: 8,
        required: false,
    },
    placement: {
        type: String as PropType<TooltipPlacement>,
        default: 'auto',
        required: false,
    },
    arrow: {
        type: Boolean as PropType<TooltipProps['arrow']>,
        default: true,
        required: false,
    },
    color: {
        type: String as PropType<TooltipProps['color']>,
        default: 'black',
        required: false,
    },
    width: {
        type: String as PropType<TooltipProps['width']>,
        default: '100%',
        required: false,
    },
    maxWidth: {
        type: String as PropType<TooltipProps['maxWidth']>,
        default: 'max-content',
        required: false,
    },
    disabled: {
        type: Boolean as PropType<TooltipProps['disabled']>,
        default: false,
        required: false,
    },
    content: {
        type: [String, Number] as PropType<TooltipProps['content']>,
        default: undefined,
        required: false,
    },
}

export const tooltipEmits = {
    [UPDATE_MODEL_VALUE]: (event: boolean) => typeof event === 'boolean',
}
